import React from "react";

import styles from "./styles.modules.scss";

import { Button } from "../button";
import { useNavigate, useParams } from "react-router-dom";

type ErrorBoundaryProps = {
    children: React.ReactNode;
};

type ErrorBoundaryState = {
    hasError: boolean;
};

const View = () => {
    const navigate = useNavigate();
    const params = useParams();

    const route = `/${params.lang ?? ""}`;

    return (
        <div className={`error ${styles.error}`}>
            <div className={`title ${styles.title}`}>Sorry!</div>

            <div className={`detail ${styles.detail}`}>
                Something did not quite work as expected...
            </div>

            <Button animationSize="large" onClick={() => navigate(route)}>
                <span className="buttonTextWrapper">BACK TO NEWS</span>
            </Button>
        </div>
    );
};

export class ErrorBoundary extends React.Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    componentDidCatch(error: any, info: any) {
        console.error(error, info);
    }

    render() {
        if (this.state.hasError) {
            return <View />;
        }

        return this.props.children;
    }
}
